module.exports = __webpack_public_path__ + "img/store_Twitter.17534b90.svg";